@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.edit-shopper-canvas {
  background-color: var(--white);
}

.drawer-header-title {
  align-self: flex-start;
  font-size: 16px;
}

.display-only-name {
  margin-top: @space-24;
  margin-bottom: @space-16;
}

.option-card-container {
  place-content: center center;
  height: 100%;
  gap: @space-24;
  padding: @space-24 108px;
}

.option-card {
  border: 1px solid var(--grey-600);
  border-radius: 8px;
  padding: @space-16;
  flex: 1 1 0;
  height: 200px;
  max-width: 600px;
}

.card-title {
  margin-bottom: @space-8;
}

.card-info {
  margin-bottom: @space-24;
}

.option-button {
  width: 204px;
  height: 50px;
}

.button-text {
  padding: @space-16 @space-24;
}
